var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('vue-snotify'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content-body"},[_c('router-view')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }